import { useHistory } from "react-router-dom";

import styled from "styled-components";

import { useMemberPortalNavItems } from "CrossFeatureComponents/MemberToolbar/stateHooks";
import { memberPortalRoutes } from "MemberPortal/Public/constants";
import {
  useIsGivePage,
  useIsHomePage,
  useIsNotesPage,
} from "MemberPortal/Public/hooks/useIsPageMatch";
import { motion } from "framer-motion";

import { colors } from "UI/colors";

import NavItem from "./NavItem";
import useNavMobileBreakpoint from "./useNavMobileBreakpoint";

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

export default function MemberPortalNav() {
  const navItems = useMemberPortalNavItems();
  const history = useHistory();
  const isHomePage = useIsHomePage();
  const isNotesPage = useIsNotesPage();
  const isGivePage = useIsGivePage();

  const handleNavClick = (path) => {
    history.push(path);
  };

  const mobileBreakpoint = useNavMobileBreakpoint();

  return (
    <Nav variants={containerVariants} initial="hidden" animate="show">
      <List $mobileBreakpoint={mobileBreakpoint}>
        {navItems.home && (
          <NavItem
            icon="fas fa-home"
            label="Home"
            color={colors.fnBlue}
            bgColor="#cde5ff"
            isActive={isHomePage}
            onClick={() => handleNavClick(memberPortalRoutes.home)}
            index={0}
          />
        )}

        {navItems.notes && (
          <NavItem
            icon="fas fa-mailbox"
            label="Notes"
            isActive={isNotesPage}
            color={colors.fnPurple}
            bgColor="#f2d8f6"
            onClick={() => handleNavClick(memberPortalRoutes.notes)}
            index={1}
          />
        )}

        {navItems.giving && (
          <NavItem
            icon="fas fa-dollar-sign"
            label="Giving"
            color={colors.fnGreen}
            bgColor="#d7ffe8"
            isActive={isGivePage}
            onClick={() => handleNavClick(memberPortalRoutes.give)}
            index={2}
          />
        )}

        {navItems.admin && (
          <NavItem
            icon="fas fa-user-shield"
            label="Admin"
            color={colors.wofOrange}
            bgColor="#ffe2cd"
            iconX={2}
            isActive={false}
            onClick={() => (window.location = "/dashboard")}
            index={3}
          />
        )}
      </List>
    </Nav>
  );
}

const Nav = styled(motion.nav)``;

const List = styled(motion.ul)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  margin: 0;
  gap: 30px;
  width: 100%;
  height: 100%;
  padding: 20px 28px 12px;

  @media (max-width: ${({ $mobileBreakpoint }) => $mobileBreakpoint}px) {
    gap: 16px;
    padding: 12px 20px 10px;
    justify-content: space-around;
  }
`;
